"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentConfigDefaults = exports.LocalEvaluationDefaults = exports.Defaults = exports.RemoteEvaluationDefaults = void 0;
/**
 Defaults for Experiment Config options

 | **Option**       | **Default**                       |
 |----------------|---------------------------------|
 | **debug**        | false                           |
 | **serverUrl**    | `"https://api.lab.amplitude.com"` |
 | **fetchTimeoutMillis**    | `10000` |
 | **fetchRetries**    | `8` |
 | **fetchRetryBackoffMinMillis**    | `500` |
 | **fetchRetryBackoffMaxMillis**    | `10000` |
 | **fetchRetryBackoffScalar**    | `1.5` |
 | **fetchRetryTimeoutMillis**    | `10000` |
 | **httpAgent** | null |

 *
 * @category Configuration
 */
exports.RemoteEvaluationDefaults = {
    debug: false,
    serverUrl: 'https://api.lab.amplitude.com',
    fetchTimeoutMillis: 10000,
    fetchRetries: 8,
    fetchRetryBackoffMinMillis: 500,
    fetchRetryBackoffMaxMillis: 10000,
    fetchRetryBackoffScalar: 1.5,
    fetchRetryTimeoutMillis: 10000,
    httpAgent: null,
};
/**
 * @deprecated use {@link RemoteEvaluationDefaults}
 */
exports.Defaults = {
    debug: false,
    serverUrl: 'https://api.lab.amplitude.com',
    fetchTimeoutMillis: 10000,
    fetchRetries: 8,
    fetchRetryBackoffMinMillis: 500,
    fetchRetryBackoffMaxMillis: 10000,
    fetchRetryBackoffScalar: 1.5,
    fetchRetryTimeoutMillis: 10000,
    httpAgent: null,
};
/**
 Defaults for {@link LocalEvaluationConfig} options.

 | **Option**       | **Default**                       |
 |----------------|---------------------------------|
 | **debug**        | false                           |
 | **serverUrl**    | `"https://api.lab.amplitude.com"` |
 | **flagConfigPollingIntervalMillis**    | `30000` |
 | **httpAgent** | null |

 * @category Configuration
 */
exports.LocalEvaluationDefaults = {
    debug: false,
    serverUrl: 'https://api.lab.amplitude.com',
    bootstrap: {},
    flagConfigPollingIntervalMillis: 30000,
    httpAgent: null,
};
exports.AssignmentConfigDefaults = {
    cacheCapacity: 65536,
};
